// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) { return "static/js/" + chunkId + "-legacy." + {"2":"ec33c9d1","466":"0ef5c02a","951":"f188116d","959":"6fd7e02a"}[chunkId] + ".js"; };